var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWandMagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.944 48L464.02 14.061C454.649 4.688 442.362 0 430.076 0S405.51 4.686 396.137 14.059L14.061 396.109C-4.685 414.854 -4.687 445.244 14.057 463.99L47.99 497.938C57.362 507.311 69.649 512 81.934 512S106.5 507.314 115.873 497.941L497.942 115.879C516.686 97.135 516.686 66.746 497.944 48ZM81.94 464.004L48 430.051L286.051 191.988L320.002 225.939L81.94 464.004ZM353.938 192L319.989 158.051L430.03 48.004C430.035 48.002 430.053 48 430.076 48L464 81.938L353.938 192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandMagic);
export default __webpack_public_path__ + "static/media/wand-magic.714915090131d7d9449df74a8aafc29f.svg";
export { ForwardRef as ReactComponent };